import { createEssentials } from '@wix/fe-essentials-standalone';
import { RootEssentialsProvider } from '@wix/fe-essentials-standalone/react';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import React, { createContext } from 'react';
import { Box, SidebarDividerNext, SidebarItemNext, SidebarNext, ThemeProvider, } from 'wix-style-react';
import { theme } from 'wix-style-react/themes/businessDashboard';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import messagesEN from '../../assets/locale/messages_en.json';
import { getPageLocationName, sendNavigationSideMenuClickBi, } from './bi/bi.utils';
import { initialState } from './helpers/testHelpers';
import { useBiLogger } from '../../useBiLogger';
import useFooterData from './hooks/useFooterData';
import { OpenState } from './OpenState/OpenState';
import { SubmissionSummary } from './side-panel/SubmissionSummary/SubmissionSummary';
export const FooterContext = createContext(initialState);
export const SideBarFooter = ({ dataFromHost, appId, navigationCallback, isPanelOpenFromDC3, setIsPanelOpenFromDC3, isWixTpa, canPublish, togglePublishModal, userId, latestVersion, appClassification, }) => {
    const biLogger = useBiLogger();
    const LOCALE = 'en';
    const essentials = createEssentials({
        environment: {
            language: LOCALE,
            artifactId: 'com.wixpress.dev-center-elements',
            version: '1.0.0',
        },
    });
    const i18n = initI18n({
        locale: LOCALE,
        messages: messagesEN,
    });
    const t = i18n.t.bind(i18n);
    const { isFooterOpen, setIsFooterOpen, isPanelOpen, blockers, recs, openPanel, closePanel, panelActiveTabId, setPanelActiveTabId, shouldCheckDismissCount, setShouldCheckDismissCount, dismissedCount, lastPublishedDate, isLoading, noVersionToSubmit, } = useFooterData({
        appId,
        navigationCallback,
        isPanelOpenFromDC3,
        setIsPanelOpenFromDC3,
        dataFromHost,
    });
    const contextValues = {
        isFooterOpen,
        setIsFooterOpen,
        isPanelOpen,
        blockers,
        recs,
        openPanel,
        closePanel,
        t,
        panelActiveTabId,
        setPanelActiveTabId,
        navigationCallback,
        noVersionToSubmit,
        appId,
        isWixTpa,
        shouldCheckDismissCount,
        setShouldCheckDismissCount,
        dismissedCount,
        canPublish,
        togglePublishModal,
        lastPublishedDate,
        userId,
        latestVersion,
        appClassification,
    };
    const onFooterClick = () => {
        closePanel();
        setIsFooterOpen(!isFooterOpen);
        const clickType = isFooterOpen
            ? 'collapse-footer'
            : 'expand-footer';
        sendNavigationSideMenuClickBi({
            biLogger,
            appId,
            sideMenuClickObject: {
                click_tag: 'submit-app-footer-open',
                click_type: clickType,
                from_page: getPageLocationName(window.location.pathname),
            },
        });
    };
    const getFooterHeight = () => {
        if (!isFooterOpen) {
            return '55px';
        }
        else if (noVersionToSubmit) {
            return isWixTpa ? '110px' : '145px';
        }
        else if (canPublish) {
            return '95px';
        }
        else if (blockers.length < 1 || isWixTpa) {
            return '175px';
        }
        else {
            return '205px';
        }
    };
    if (isLoading) {
        return React.createElement("div", null);
    }
    return (React.createElement(RootEssentialsProvider, { essentials: essentials },
        React.createElement(I18nextProvider, { i18n: i18n },
            React.createElement(FooterContext.Provider, { value: contextValues },
                React.createElement(Box, { height: getFooterHeight(), dataHook: "sidebar-footer-main-box" },
                    React.createElement(ThemeProvider, { theme: theme({ active: true }) },
                        React.createElement(SidebarDividerNext, { fullWidth: true }),
                        React.createElement(SidebarNext, { selectedKey: "0", isLoading: false },
                            !canPublish && (React.createElement(SidebarItemNext, { suffix: React.createElement(ChevronDown, null), onClick: onFooterClick }, t('sg.footer.title'))),
                            isFooterOpen ? React.createElement(OpenState, null) : null))),
                React.createElement(SubmissionSummary, null)))));
};
//# sourceMappingURL=SideBarFooter.js.map